import {
    ChevronIconComponent as SourceChevronIconComponent,
} from 'SourceComponent/ChevronIcon/ChevronIcon.component';
import React from 'react';

export class ChevronIconComponent extends SourceChevronIconComponent {
    render() {
        const { direction } = this.props;

        return (
            <svg className={`ChevronIcon ChevronIcon_direction_${direction}`} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.25 6.5L14.75 12L9.25 17.5" stroke="#969696" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        );
    }
}

export default ChevronIconComponent;
